export const iconFontAwesomeTransportationFerry = (
	<i className="fa-solid fa-ferry"></i>
);
